import { ApiFrdFrdsListRequest, FRD } from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const frdInformation: SearchOption<keyof FRD, keyof ApiFrdFrdsListRequest>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "BRO-ID" },
  { key: "gmwBroId", searchKey: "gmwBroIdIcontains", label: "Put-ID" },
  { key: "tubeNumber", label: "Buisnummer" },
  { key: "researchFirstDate", label: "Eerste datum" },
  { key: "researchLastDate", label: "Laatste datum" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
];
